import { APP_INITIALIZER } from '@angular/core';
import { DEFAULT_SCHEMES, ThemeSettingsService, TypeTheme, UiSettingsQuery, } from '@ho/shared/data-access/ui-settings';
export const uiSettingsInitializerProvider = {
    provide: APP_INITIALIZER,
    useFactory: (uiSettingsQuery, themeSettingsService) => () => {
        var _a;
        if (!!((_a = uiSettingsQuery.queryThemeSettings) === null || _a === void 0 ? void 0 : _a.selected_color_scheme)) {
            themeSettingsService.applyThemes(Object.assign(Object.assign({}, DEFAULT_SCHEMES), { 
                // selected_color_scheme: uiSettingsQuery.queryThemeSettings.selected_color_scheme,
                selected_color_scheme: TypeTheme.PurpleLight }));
        }
        else {
            themeSettingsService.applyThemes(Object.assign(Object.assign({}, DEFAULT_SCHEMES), { selected_color_scheme: TypeTheme.PurpleLight }));
        }
    },
    multi: true,
    deps: [UiSettingsQuery, ThemeSettingsService],
};
